import moment from 'moment';
import get from 'lodash/get';
import { getDaysInMonth, getRestOfElementsBetweenTwoArray, getTranslatedMessage, getCookie } from '../../../utils';

// const { RS_WKS_FLAG } = window.weeksWebCloudConfig;
export const groupByDateofUnitDetails = (unitDetails, unitType, unitTypeCheckInDateMap) => {
  let modifiedUnitDetails = [];
  let availableDateOfUnitsFromQuery = [];
  let availableDateOfUnits = Object.keys(unitDetails || []);
  if (unitType && unitType.selectedUnitVal) {
    const SelectedUnitType = Object.keys(unitTypeCheckInDateMap || []);
    const findInsexUnitType = SelectedUnitType.findIndex(
      value => value === unitType.selectedUnitVal,
    );
    const unitTypesArray = SelectedUnitType.slice(findInsexUnitType, SelectedUnitType.length);
    availableDateOfUnits.forEach((unitsEachInfo) => {
      unitTypesArray.forEach((element) => {
        if (unitsEachInfo.includes(element)) {
          availableDateOfUnitsFromQuery = [...availableDateOfUnitsFromQuery, unitsEachInfo];
        }
      });
    });
  }
  availableDateOfUnits = availableDateOfUnitsFromQuery.length > 0
    ? availableDateOfUnitsFromQuery : availableDateOfUnits;
  availableDateOfUnits.forEach((eachUnitOfDate) => {
    modifiedUnitDetails = [...modifiedUnitDetails, ...unitDetails[eachUnitOfDate]];
  });
  return modifiedUnitDetails;
};

export const groupByDateofUnitAndPriceDetails = (unitDetails, exstingUnitDetails) => {
  let modifiedUnitDetails = [];
  const availableDateOfUnits = Object.keys(unitDetails);
  availableDateOfUnits.forEach((eachUnitOfDate) => {
    modifiedUnitDetails = [...modifiedUnitDetails, ...unitDetails[eachUnitOfDate]];
  });

  const featureFlagSearch = 'true';
  if (featureFlagSearch && featureFlagSearch.toLowerCase() === 'true') {
    return [...(exstingUnitDetails || []), ...modifiedUnitDetails];
  }
  /* istanbul ignore next -- dead code: featureFlagSearch hardcoded 'true' */
  if (exstingUnitDetails.length === modifiedUnitDetails.length) {
    return modifiedUnitDetails;
  }

  exstingUnitDetails.splice(
    exstingUnitDetails.length - modifiedUnitDetails.length, exstingUnitDetails.length,
  );
  return [...exstingUnitDetails, ...modifiedUnitDetails];
  // }
  // return modifiedUnitDetails;
};


export const getDayNameFromDate = (value) => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const d = new Date(value);
  const dayName = days[d.getDay()];
  return dayName;
};

export const removeDuplicateElementFromArrayOfObjects = (arr, keyName) => {
  const filteredArr = arr.reduce((acc, current) => {
    const x = acc.find(item => item[keyName] === current[keyName]);
    if (!x) {
      return acc.concat([current]);
    }
    return acc;
  }, []);
  return filteredArr;
};

export const getNextAvaialableMonth = (nextMonth, availableCalenderData) => {
  const year = (+moment(nextMonth).format('M') + 1) >= 13 ? moment(nextMonth).format('YYYY') + 1
    : moment(nextMonth).format('YYYY');
  const nextAvialableMonth = availableCalenderData.findIndex(
    date => +moment(date).format('M') === +moment(nextMonth).format('M') + 1
    && moment(date).format('YYYY') === year,
  );
  const nextAvialableMonths = nextAvialableMonth !== -1 ? availableCalenderData[nextAvialableMonth] : '';
  return nextAvialableMonths;
};

export const getMonth = (minStartDates) => {
  if (minStartDates) {
    const year = minStartDates.substring(0, 4);
    const month = minStartDates.substring(5, 7);
    const day = minStartDates.substring(8, 10);
    return new Date(year, Number(month) - 1, day);
  }
  return new Date();
};

export const getNotAvailableDays = (currentmonth, availableCalenderData) => {
  const currentdate = moment(currentmonth);
  const currentMonth = +currentdate.format('M') - 1;
  const cuurentYear = currentdate.format('YYYY');
  const allDaysinMonths = getDaysInMonth(currentMonth, cuurentYear);
  const avialabledate = availableCalenderData.map(date => getMonth(date));
  const notAvailableDate = getRestOfElementsBetweenTwoArray(allDaysinMonths, avialabledate);
  return notAvailableDate;
};

export const getNextdate = (CurrentDate, availableDate) => availableDate.findIndex(
  (date) => {
    const a = moment(CurrentDate);
    const b = moment(date);
    return (a.isBefore(b, 'month'));
  },
);

export const sortDates = (a, b) => (
  moment(a) - moment(b)
);

export const getKey = (data, unitTypeKey, extractUnitAndDates = false) => {
  const unitTypeArray = [];
  const dateArray = [];

  if (data) {
    Object.keys(data).forEach((key) => {
      const parts = key.split('_');
      if (parts.length > 1 && !unitTypeArray.includes(parts[1])) {
        unitTypeArray.push(parts[1]);
      }
      const unitArr = data[key];
      if (Array.isArray(unitArr) && unitArr.length > 0) {
        unitArr.forEach(unit => {
          if (unit.checkInDate && !dateArray.includes(unit.checkInDate)) {
            dateArray.push(unit.checkInDate);
          }
        });
      }
    });
    const sortedDates = dateArray.sort((a, b) => new Date(a) - new Date(b));
    return {
      availableUnit: unitTypeArray,
      availableDate: sortedDates,
      selectedDateObject: {},
    };
  }
  return {
    availableUnit: [],
    availableDate: [],
    selectedDateObject: {},
  };
};

export const getKeyWhenDateIsSelected = (unitDetailsInfo, selectedUnit, selectedDateObject) => {
  const keyArray = [];
  let valueArray = [];

  const keyOfTheSavedUnitDetails = Object.keys(unitDetailsInfo);
  if (selectedUnit === 'ALL') {
    keyOfTheSavedUnitDetails.forEach((eachDetailsKey) => {
      keyArray.push(eachDetailsKey);
      valueArray = valueArray.concat(unitDetailsInfo[eachDetailsKey]);
    });
  } else {
    const getUnitKey = keyOfTheSavedUnitDetails.slice(
      keyOfTheSavedUnitDetails.indexOf(selectedUnit), keyOfTheSavedUnitDetails.length,
    );
    getUnitKey.forEach((eachDetailsKey) => {
      keyArray.push(eachDetailsKey);
      valueArray = valueArray.concat(unitDetailsInfo[eachDetailsKey]);
    });
  }
  const dateArray = valueArray.filter((a, b) => valueArray.indexOf(a) === b);
  const sortedDates = dateArray.sort(sortDates);
  return {
    availableUnit: keyArray,
    availableDate: sortedDates,
    selectedDateObject,
  };
};
export const getSelectedDateWithunitType = (unitDetailsInfo, selectedUnit, selectedDate) => {
  const keyArray = [];
  const keyOfTheSavedUnitDetails = Object.keys(unitDetailsInfo);
  if (selectedUnit === 'ALL') {
    keyOfTheSavedUnitDetails.forEach((eachDetailsKey) => {
      unitDetailsInfo[eachDetailsKey].forEach((keyValue) => {
        if (keyValue === selectedDate) {
          const eachDetailsKeys = `${keyValue}_${eachDetailsKey}`;
          keyArray.push(eachDetailsKeys);
        }
      });
    });
  } else {
    const getUnitKey = keyOfTheSavedUnitDetails.slice(
      keyOfTheSavedUnitDetails.indexOf(selectedUnit), keyOfTheSavedUnitDetails.length,
    );
    getUnitKey.forEach((eachDetailsKey) => {
      unitDetailsInfo[eachDetailsKey].forEach((keyValue) => {
        if (keyValue === selectedDate) {
          const eachDetailsKeys = `${keyValue}_${eachDetailsKey}`;
          keyArray.push(eachDetailsKeys);
        }
      });
    });
  }
  return keyArray;
};

export const getWeekRange = date => ({
  from: moment(date)
    .startOf('day')
    .toDate(),
});

export const getWeekDays = (dayStart, durationDaySelected, falg = false) => {
  let days = [];
  if (falg) {
    days.push(
      moment(dayStart)
        .toDate(),
    );
  } else {
    days = [dayStart];
  }
  for (let i = 1; i < durationDaySelected; i += 1) {
    days.push(
      moment(dayStart)
        .add(i, 'days')
        .toDate(),
    );
  }
  return days;
};

export const checkEligibleForBooking = unitConfigurations => (
  unitConfigurations.find(element => !element.eligibleForBooking)
);
export const checkRestricted = unitConfigurations => (
  unitConfigurations.find(element => element.restricted)
);

export const checkEligibleForBookingMandatory = (visibleunitdetails, unitConfigurations) => (
  visibleunitdetails.find(element => !element.eligibleForBooking
    && unitConfigurations.productID === element.productID
    && get(element, 'calculatefees'))
);
export const checkRestrictedMandatory = (visibleunitdetails, unitConfigurations) => (
  visibleunitdetails.find(element => element.restricted
    && unitConfigurations.productID === element.productID
    && get(element, 'calculatefees'))
);

export const kitchenTypeArray = (selectedUnit, messageContent) => {
  const kitchenTypeArrays = {
    N: { label: getTranslatedMessage(messageContent, 'PWE_WOW_AvailableUnit', 227, 'No kitchen'), messageId: 'PWE_WOW_AvailableUnit_227' },
    P: { label: getTranslatedMessage(messageContent, 'PWE_WOW_AvailableUnit', 77, 'Partial kitchen'), messageId: 'PWE_WOW_AvailableUnit_77' },
    M: { label: getTranslatedMessage(messageContent, 'PWE_WOW_AvailableUnit', 228, 'Mini kitchen'), messageId: 'PWE_WOW_AvailableUnit_228' },
    F: { label: getTranslatedMessage(messageContent, 'PWE_WOW_AvailableUnit', 76, 'Full kitchen'), messageId: 'PWE_WOW_AvailableUnit_76' },
  };
  return kitchenTypeArrays[selectedUnit];
};

/**
 * Sort inventory array:
 */
export const getGroupedVisibleUnitDetails = (items) => {
  if (!Array.isArray(items)) return [];

  return [...items].sort((a, b) => {
    if (a.checkInDate < b.checkInDate) return -1;
    if (a.checkInDate > b.checkInDate) return 1;

    const ua = Number(a.bedRoomCode);
    const ub = Number(b.bedRoomCode);
    if (ua < ub) return -1;
    if (ua > ub) return 1;

    const ida = Number(a.productID);
    const idb = Number(b.productID);
    if (ida < idb) return -1;
    if (ida > idb) return 1;

    return 0;
  });
}

export function normalizeProductType(str) {
  switch (str) {
    case "exchange":
      return "Exchange";
    case "lastcall":
      return "LastCall";
    case "extravacation":
      return "ExtraVacation";
    default:
      return str;
  }
}

export const getMatchingBedroomConfig = (selectedBedroom, unitConfigurations) => {
  if (!selectedBedroom || !unitConfigurations || !Array.isArray(unitConfigurations)) {
    return null;
  }
  
  const matchedConfig = unitConfigurations.find(config => 
    config.bedRoomCode === selectedBedroom
  );
  
  return matchedConfig || null;
};
